import { AuthenticationService } from './../../services/user/authentication.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute} from '@angular/router';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { UserService } from 'src/app/services/user/user.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  
  LoginForm: FormGroup;
  submitted = false;
  UserName:AbstractControl;
  Password:AbstractControl;
  
  loading = false;
 
  returnUrl: string;
 
  
  constructor(private formBuilder: FormBuilder,private globalHelper:GlobalHelper, private  authenticationService:AuthenticationService, private router:Router,private userService:UserService) { 
   
 
  
  }
  
  ngOnInit() {
    
    this.globalHelper.SiteMap=null;
    this.LoginForm = this.formBuilder.group({
      UserName: ['', Validators.required],
      Password: ['', [Validators.required, Validators.minLength(1)]],      
  });

  } 

  
  get f() { return this.LoginForm.controls; }
 
 OnGetToken(){
  
   this.globalHelper.SiteMap=null;   
   this.submitted = true;
   this.UserName= this.LoginForm.controls['UserName'].value;
   this.Password=this.LoginForm.controls['Password'].value;
  
  //  if (this.LoginForm.invalid) {
  //   return;
  //    }

  this.authenticationService.UserAuthentication(this.UserName,this.Password).subscribe((data:any)=>{
     
    var LoginToken =JSON.parse(data.LoginToken);
     
    if(LoginToken.LoginStatus=='OK')
    {
    
    this.globalHelper.SetUserToken(data.access_token);   
      this.globalHelper.SetToken(data.LoginToken);
      
    // window.localStorage.setItem("LoginToken", data.LoginToken); 
    //this.globalHelper.LoginToken=  JSON.parse(data.LoginToken);
  
     if(data.access_token!=null &&  this.globalHelper.GetLoginToken().UserTypeID==6 ){
        this.router.navigate(['/superadmin/dashboard']);
     }
     else if(data.access_token!=null &&  this.globalHelper.GetLoginToken().UserTypeID==8 ){
       this.router.navigate(['/channelpartner/dashboard']);
     }
     else if(data.access_token!=null &&  this.globalHelper.GetLoginToken().UserTypeID==7 ){
      this.router.navigate(['/dashboard']);
    }    
    //  else if(data.access_token!=null &&this.globalHelper.GetLoginToken().IsSMSPackage){
    //   this.router.navigate(['/dashboard']);
    //  }
   else if(data.access_token!=null){
       if(this.globalHelper.GetLoginToken().UserTypeID!=5){
        if(this.globalHelper.GetLoginToken().SessionCount>0){
        this.router.navigate(['/academicselection']);
        }
        else{
          this.router.navigate(['/createsession']);
        }
       }
       else{
        this.router.navigate(['/dashboard']);
       }
     }
    }
     else{
      alert('Please enter Valid Username and Password.');
     }
   });

  }
  // GetUserRight(){
  //   this.userService.GetUserRight().subscribe((data:any)=>{
    
  //     // this.globalHelper.SiteMap=  JSON.parse(data.BranchRolePermissionList);
       
  //    });

  // }
}
